"use strict";

var _default2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var actions = _interopRequireWildcard(require("./actions"));

var _initialState = _interopRequireDefault(require("./initial-state"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var _default = (_default2 = {}, _defineProperty(_default2, actions.resetConfiguration, function (state) {
  return _objectSpread({}, _initialState["default"]);
}), _defineProperty(_default2, actions.setConfiguration, function (state, _ref) {
  var payload = _ref.payload;
  return _objectSpread({}, state, {}, payload);
}), _defineProperty(_default2, actions.patchConfiguration, function (state, _ref2) {
  var payload = _ref2.payload;
  var otherParams = {}; // If the user is setting the visualisation to be a map, we set some of its default parameters

  if ((payload === null || payload === void 0 ? void 0 : payload.visualizationType) === 'map') {
    var _state$map$basemap, _state$map$basemap$ba, _state$map$basemap2, _state$map$basemap$la, _state$map$basemap3, _state$map$basemap$bo, _state$map$basemap4;

    otherParams.map = _objectSpread({}, state.map, {
      basemap: _objectSpread({}, (_state$map$basemap = state.map.basemap) !== null && _state$map$basemap !== void 0 ? _state$map$basemap : {}, {
        basemap: (_state$map$basemap$ba = (_state$map$basemap2 = state.map.basemap) === null || _state$map$basemap2 === void 0 ? void 0 : _state$map$basemap2.basemap) !== null && _state$map$basemap$ba !== void 0 ? _state$map$basemap$ba : 'dark',
        labels: (_state$map$basemap$la = (_state$map$basemap3 = state.map.basemap) === null || _state$map$basemap3 === void 0 ? void 0 : _state$map$basemap3.labels) !== null && _state$map$basemap$la !== void 0 ? _state$map$basemap$la : 'none',
        boundaries: (_state$map$basemap$bo = (_state$map$basemap4 = state.map.basemap) === null || _state$map$basemap4 === void 0 ? void 0 : _state$map$basemap4.boundaries) !== null && _state$map$basemap$bo !== void 0 ? _state$map$basemap$bo : false
      })
    });
  }

  return _objectSpread({}, state, {}, payload, {}, otherParams);
}), _default2);

exports["default"] = _default;